import { green } from "@mui/material/colors";

export const milestoneStyles = {
  milestoneContainer: {
    borderRadius: "8px",
    backgroundColor: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  container: {
    borderRadius: "8px",
    backgroundColor: "#FFFFFF",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    padding: "16px 0",
  },
  stickyHeader: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "#FFFFFF",
    padding: "0 12px",
  },
  scrollableContent: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    padding: "8px 12px",
    "&:focus": {
      outline: "2px solid #1976d2",
      outlineOffset: "2px",
    },
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "1px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#c1c1c1",
      borderRadius: "1px",
      "&:hover": {
        background: "#a8a8a8",
      },
    },
  },
  headerSection: {
    width: "484px",
    height: "48px",
    paddingTop: "8",
    gap: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  statusBadge: {
    marginLeft: "8px",
    borderRadius: "20px",
    padding: "4px 8px",
    backgroundColor: green[50],
    color: green[900],
    fontSize: "0.875rem",
  },
  accordion: {
    marginBottom: "8px",
    background: "#FAFBFC",
    gap: "8px",
    borderRadius: "8px 0 0 0",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
    border: "none",
  },
  taskItem: {
    gap: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: "16px",
    marginBottom: "8px",
  },
  noTasks: {
    marginLeft: "16px",
    color: "#999",
  },
  badge: {
    "& .MuiBadge-badge": {
      height: "16px",
      minWidth: "16px",
      fontSize: "10px",
    },
  },
  exceptionBadge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#C93939",
      color: "white",
    },
  },
  alertBadge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#C58026",
      color: "white",
    },
  },
  noteBadge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#3F63C0",
      color: "white",
    },
  },
  completionDate: {
    color: "#11834A",
    backgroundColor: "#EFFBF5",
    borderRadius: "20px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
  },
  dueDate: {
    backgroundColor: "#E7ECF0",
    borderRadius: "20px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
  },
  accordionSummary: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "4px",
    paddingLeft: "8px",
    paddingRight: "8px", // Keeps icons aligned on the right
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px", // Reduce spacing between checkbox and title
    flex: 1, // Allows the title to occupy available space
  },
  milestoneTitle: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#5B7282",
    whiteSpace: "wrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between", // Ensures even spacing between icons
    gap: "16px", // Spacing between icons
    width: "120px", // Fixed width for consistency
    flexShrink: 0, // Prevents shrinking
    marginRight: "12px",
  },
  checkbox: {
    padding: "4px", // Reduce padding around the checkbox
    marginLeft: "0px", //
  },
  indeterminate: {
    color: "#5B7282",
    padding: "4px", // Reduce padding around the checkbox
    marginLeft: "0px", //
    cursor: "auto",
    "&.Mui-disabled": {
      color: "#5B7282",
    },
  },
  icon: {
    fontSize: "20px",
  },
}; 